import { render } from "./card.vue?vue&type=template&id=c7c77518"
const script = {}
script.render = render

export default script